import { StateSubject } from './state-subject';
import { User } from '../interfaces/user.model';

export class UserState extends StateSubject<User>
{
  constructor()
  {
    const defaults: Required<User> = {
      id: 0,
      name: '',
      pictureUrl: '',
      phoneNo: '',
    };
    super(defaults);
  }
}
